import { Collections } from "@diacare/common/models/collections";
import { FieldType } from "@litbase/admin";
import { UserInterface } from "@litbase/core";
import { QuestionMark } from "@styled-icons/boxicons-regular";
import { ExtendedModelConfig } from "./index";

export const questionConfig: ExtendedModelConfig = {
  name: Collections.QUESTIONS,
  displayName: "Questions",
  singleName: "Question",
  newLabel: "New question",
  listLabel: "Questions",
  fields: {
    title: { type: FieldType.string, displayName: "Title" },
    description: { type: FieldType.text, displayName: "Description" },
    // Keep the persisted legacy names for compatibility with installed mobile clients.
    images: { type: FieldType.files, displayName: "Attachments" },
    createdAt: { type: FieldType.date, displayName: "Created at" },
    userId: {
      type: FieldType.doc,
      displayName: "User",
      placeholder: "Choice...",
      joinConfig: {
        otherCollection: Collections.USERS,
        searchableFields: ["name"],
        getLabel: (user) => (user as unknown as UserInterface).name,
      },
    },
    user: {
      displayName: "User",
      type: FieldType.object,
      virtual: true,
      getLabel: "name",
    },
    answer: {
      type: FieldType.text,
      displayName: "Reply",
    },
    answerImages: {
      type: FieldType.files,
      displayName: "Attachments for the answer",
    },
  },
  icon: QuestionMark,
  queryFields: {
    _id: 1,
    title: 1,
    description: 1,
    images: 1,
    userId: 1,
    answer: 1,
    answerImages: 1,
    createdAt: 1,
    user: {
      _id: 1,
      name: 1,
    },
  },
};
